<template>
  <div class="map-btn-container" style="overflow-x: hidden">
    <yandex-map
      :coords="coords"
      :zoom="zoom"
      @map-was-initialized="onInit"
      @click="mapClicked++"
      :controls="controls"
      :use-object-manager="true"
    >
      <point-panel
        :content="pointPanel"
        @close="onPanelChangeView(false)"
        @open="onPanelChangeView(true)"
      />
      <simple-search 
        :point-panel="pointPanel"
        :map-click="mapClicked"
        @close="onPanelChangeView(true)"
      />
      <my-notify :map-click="mapClicked" />
      <my-book @btn-click="mapClicked++" />
      <transition
        name="fade"
        mode="in-out"
      >
        <router-view></router-view>
      </transition>
    </yandex-map>
  </div>
</template>

<script>
const CENTER = [58.59, 49.66];
const ZOOM = 7;
const AREA = [
  [80, 20],
  [40, 80],
];
import { MapModules } from "@/MapModules";
import pointPanel from "./PanelComponent.vue";
import SimpleSearch from './SimpleSearch.vue';
import myNotify from './myNotify.vue';
import myBook from './myBook.vue';

export default {
  data: () => ({
    coords: CENTER,
    zoom: ZOOM,
    restrictMapArea: AREA,
    controls: [
      //   "geolocationControl",
      //   "zoomControl",
      //   "typeSelector",
      //   "fullscreenControl",
    ],
    pointPanel: {
      head: "Расширенный поиск",
      show: false,
    },
    mapClicked: 0
  }),
  computed: {
    terms() {
      return this.$store.getters.termfilter;
    },
  },
  watch: {
    terms() {
      this.$store.dispatch("rePrintPoints");
    }
  },
  methods: {
    // действия после инициализации карты
    onInit(e) {
      // запоминаем карту в глобальной переменной
      window.myMap = e;
      window.myMap.options.set("restrictMapArea", this.restrictMapArea);
      // выбираем подложку
      // e.setType('yandex#satellite')
      window.myMap.copyrights.add("© ВятГУ, коллектив авторов");
      // активируем свои органы управления на карте
      // MapModules.buttonsInit(this);
      // настраиваем область видимости карты
      if (this.pointPanel.show) MapModules.addPanelArea(this.pointPanel.show);
      // загружаем данные
      this.dataLoad();
      // Прячем капчу
      this.$recaptchaInstance.hideBadge();
    },

    // скрытие/показ панели объектов
    onPanelChangeView(show) {
      // обновляем флаг показа панели
      this.pointPanel.show = show;
      // настраиваем область видимости карты (чтобы объекты не отображались под панелью)
      MapModules.addPanelArea(show);
    },

    // выбирает все районы и все категории в расширенном фильтре
    selectAllFilters() {
      this.$store.state.regions.filter.forEach(reg => {
        reg.selected = true
        window.borderManager.objects.setObjectOptions(reg.id, Object.assign({}, this.$store.state.regions.borders.style.selected))
      })
      this.$store.state.categories.filter.forEach(cat => {
        cat.selected = true
      })
    },

    // загрузка данных
    async dataLoad() {
      try {
        // Категории
        await this.$store.dispatch("CatsLoader");
        // Связи терминов и категорий
        await this.$store.dispatch("TermsCatLoader");
        // Районы и их границы
        var polygons = await this.$store.dispatch("BordersLoader");
        // конвертация координат районов в GeoJSON
        var regions = MapModules.GeoJSONFactory(polygons);
        // вывод границ районов на карту
        MapModules.BordersPrint(regions, e => {
          // событие по клику на район
          this.$store.commit("regSelectionChange", e);
        });
        // Связи терминов и районов
        await this.$store.dispatch("TermsLocLoader");
        // Названия терминов
        await this.$store.dispatch("TermsLoader");
        // Фиктивные геоточки
        await this.$store.dispatch("PointsLoader");
        this.$Loading.finish();
        this.selectAllFilters();
      } catch (e) {
        console.log(e);
        this.$Loading.error();
      }
    },
  },
  components: {
    // панель объектов
    pointPanel,
    // поле поиска
    SimpleSearch,
    // всплывающее сообщение
    myNotify,
    myBook
  },
  //действия при инициализации модуля (до загрузки карты)
  created() {
    // активация линии загрузки
    this.$Loading.start();
    if (!document.location.hash.split('/')[1])
      this.$router.push({ path: 'index' });
  },
};
</script>

<style lang="scss">
@import "@/scss/index.scss";
@import url("/static/lang/fonts/century-gothic.css");
@import url("/static/lang/fonts/izhitsa-cyrillic.css");

#app,
.map-btn-container {
  width: 100%;
  height: calc(100vh - 26px);
  min-width: 300px;
  padding-top: 26px;
}

.ymap-container {
  height: 100%;
  position: relative;
}

.at-select__list {
  margin-bottom: 0 !important;
}

.at-modal__title p {
  margin-bottom: 0 !important;
  color: red;
  font-size: 200%;
}

.at-modal__title {
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
    display: block !important;
}

.at-modal__close {
    font-size: 37px;
    color: red;
}

.at-collapse__header {
  padding-top: 10px;
  padding-right: 18px;
}

.indexpage .at-modal__mask {
  background: none !important;
}

.at-modal__back {
    font-size: 37px;
    color: red;
    position: absolute;
    top: 16px;
    left: 16px;
    line-height: 1;
    overflow: hidden;
    cursor: pointer;
}

@media (max-width: 576px) {
 .at-modal {
    top: 52px;
    width: 100vw !important;
  }
  .searchitem__body {
    min-height: calc(100vh - 206px) !important;
  } 
}
</style>
